import { queryClient } from 'modules/app';
import { fetchAccountInformation } from 'modules/authentication/helpers/auth';
import { requestOptionsWithSessionToken } from 'modules/authentication/helpers/requestHelper';
import { unstable_batchedUpdates } from 'react-dom';
import useAuthStore from '~/authentication/store';

const requestUrl = `${URL_AUTHENTICATION_HOST}/api/v1/admin/impersonate`;

export const impersonate = async (userId: string): Promise<Response> => {
  const requestOptions: RequestInit = requestOptionsWithSessionToken(
    {
      body: JSON.stringify({ userId }),
      method: 'POST',
      mode: 'cors',
    },
    useAuthStore.getState().token,
  );

  const response = await fetch(requestUrl, requestOptions);

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Failed to impersonate user');
  }

  // Update the authentication store with the new user information
  unstable_batchedUpdates(() => {
    useAuthStore.getState().setToken(data.newToken);
  });

  await fetchAccountInformation(useAuthStore.getState());

  queryClient.clear();

  return response;
};

export const becomeYourself = async (): Promise<Response> => {
  const requestOptions: RequestInit = requestOptionsWithSessionToken(
    {
      method: 'DELETE',
    },
    useAuthStore.getState().token,
  );

  const response = await fetch(requestUrl, requestOptions);

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.error || 'Failed to impersonate user');
  }

  // Update the authentication store with the new user information
  unstable_batchedUpdates(() => {
    useAuthStore.getState().setToken(data.newToken);
  });
  await fetchAccountInformation(useAuthStore.getState());

  queryClient.clear();

  return response;
};
